import { render, staticRenderFns } from "./GeneralDash.vue?vue&type=template&id=13584121"
import script from "./GeneralDash.vue?vue&type=script&lang=js"
export * from "./GeneralDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports